import { ComponentRef, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { from, Observable, of, Subject } from 'rxjs';
import { CreatePersonComponent } from '../create-person/create-person.component';
import { PermissionService } from '@web-frontend/shared/services/permissions';
import { IUser } from '@tacliatech/types';
import { switchMap, catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SubscriptionService } from '@web-frontend/shared/services/subscription';

@Injectable({
  providedIn: 'root',
})
export class CreatePersonService {
  private refreshListSource = new Subject<boolean>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(
    private dialog: MatDialog,
    private permissionsService: PermissionService,
    private readonly router: Router,
    private subscriptionService: SubscriptionService
  ) {}

  open(config?: MatDialogConfig): Observable<IUser | undefined> {
    return from(this.subscriptionService.canAddPlanSeats()).pipe(
      switchMap((canAdd) => {
        if (!canAdd) return of(undefined);

        return this.dialog
          .open(CreatePersonComponent, config)
          .afterClosed()
          .pipe(
            tap((res) => {
              if (res) this.refreshListSource.next(res);
            })
          );
      }),
      catchError(() => {
        return of(undefined);
      })
    );
  }
}
